import { api } from "@/api";
import {
  invalidateStorageQueries,
  type StorageBooking,
  type StorageLocation,
} from "./storage";

/** The manual in/out override. The reason goes into the booking's history. */
export const setStorageLocation = async (
  bookingId: string,
  location: StorageLocation,
  reason: string,
) => {
  const { body } = await api.post<StorageBooking>(
    `/storage/bookings/${bookingId}/location`,
    { body: { location, reason } },
  );
  invalidateStorageQueries();
  return body;
};
